import React, { useState } from 'react';
import { LogOut, Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { CambioPasswordModal } from '../components/modals/CambioPasswordModal';
import { NotificationSettings } from '@/components/ui/NotificationSettings';

/**
 * Página de perfil de usuario
 */
export const Perfil: React.FC = () => {
  const { user, logout } = useAuth();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  /**
   * Obtiene las iniciales del nombre del usuario
   */
  const getUserInitials = (): string => {
    if (!user?.nombre) return 'U';
    
    const names = user.nombre.split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[1][0]}`.toUpperCase();
    }
    return user.nombre[0].toUpperCase();
  };

  /**
   * Maneja el cierre de sesión
   */
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  /**
   * Abre el modal de cambio de contraseña
   */
  const handleChangePassword = () => {
    setShowPasswordModal(true);
  };

  return (
    <div className="flex-1 p-4">
      <div className="space-y-6">
        {/* Información del usuario */}
        <div className="bg-secondary-800 rounded-xl p-6 border border-secondary-700">
          <div className="flex items-center space-x-4 mb-4">
            <div className="w-16 h-16 bg-primary-500 rounded-full flex items-center justify-center">
              <span className="text-white text-xl font-bold">
                {getUserInitials()}
              </span>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-secondary-50">
                {user?.nombre || 'Usuario'} {user?.apellidos || 'Apellidos'}
              </h2>
              <p className="text-secondary-400">
                {user?.email || 'usuario@email.com'}
              </p>
            </div>
          </div>
        </div>

        {/* Configuración de Notificaciones */}
        <NotificationSettings />
        
        {/* Opciones */}
        <div className="space-y-3">
          
          {/* Botón de cambio de contraseña */}
          <button 
            onClick={handleChangePassword}
            className="w-full bg-secondary-800 rounded-lg p-4 border border-secondary-700 flex items-center justify-between hover:bg-secondary-700 transition-colors"
          >
            <div className="flex items-center space-x-3">
              <Lock className="h-5 w-5 text-secondary-400" />
              <span className="text-secondary-50">Cambiar Contraseña</span>
            </div>
          </button>
          
          <button 
            onClick={handleLogout}
            className="w-full bg-red-500/10 border border-red-500/20 rounded-lg p-4 flex items-center justify-between hover:bg-red-500/20 transition-colors"
          >
            <div className="flex items-center space-x-3">
              <LogOut className="h-5 w-5 text-red-400" />
              <span className="text-red-400">Cerrar Sesión</span>
            </div>
          </button>
        </div>
      </div>

      {/* Modal de cambio de contraseña */}
      <CambioPasswordModal
        isOpen={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
      />
    </div>
  );
};

export default Perfil;